"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicSDK = void 0;
const ethers_1 = require("ethers");
const axios_1 = __importDefault(require("axios"));
const misc_1 = __importDefault(require("./modules/misc"));
const supply_1 = __importDefault(require("./modules/supply"));
const borrow_1 = __importDefault(require("./modules/borrow"));
const erc20_1 = __importDefault(require("./modules/erc20"));
const erc721_1 = __importDefault(require("./modules/erc721"));
const market_1 = __importDefault(require("./modules/market"));
const oracle_1 = __importDefault(require("./modules/oracle"));
const tonic_1 = __importDefault(require("./modules/tonic"));
const liquidate_1 = __importDefault(require("./modules/liquidate"));
const staking_1 = __importDefault(require("./modules/staking"));
const vault_1 = __importDefault(require("./modules/vault"));
const order_1 = __importDefault(require("./modules/order"));
const boost_1 = __importDefault(require("./modules/boost"));
const base_1 = require("./base");
const customized_gas_web3_provider_1 = require("./misc/customized-gas-web3-provider");
class TectonicSDK extends base_1.TectonicSDKBase {
    constructor(abiOrAbiUrl) {
        super();
        this.Misc = new misc_1.default(this);
        this.ERC20 = new erc20_1.default(this);
        this.ERC721 = new erc721_1.default(this);
        this.Market = new market_1.default(this);
        this.Supply = new supply_1.default(this);
        this.Borrow = new borrow_1.default(this);
        this.Oracle = new oracle_1.default(this);
        this.Tonic = new tonic_1.default(this);
        this.Liquidate = new liquidate_1.default(this);
        this.Staking = new staking_1.default(this);
        this.Vault = new vault_1.default(this);
        this.Order = new order_1.default(this);
        this.Boost = new boost_1.default(this);
        if (typeof abiOrAbiUrl === 'string') {
            this.abiUrl = abiOrAbiUrl;
        }
        else {
            this.world = abiOrAbiUrl.contracts;
        }
    }
    async initWithProvider(provider, config) {
        let externalProvider;
        const injectedProvider = provider;
        if (injectedProvider._isProvider) {
            // this.provider = injectedProvider;
            // console.log("Using injected provider");
            // console.log(injectedProvider['provider']);
            externalProvider = injectedProvider['provider'];
        }
        else {
            externalProvider = provider;
        }
        if (config && config.gasFeeMultiplier) {
            // console.log("Using customized gas fee multiplier");
            this.provider = new customized_gas_web3_provider_1.CustomizedGasWeb3Provider(config.gasFeeMultiplier, externalProvider);
        }
        else {
            this.provider = new ethers_1.ethers.providers.Web3Provider(externalProvider);
        }
        await this.initWorld();
    }
    async initWithRpc(rpcUrl, useWebSocket, signer) {
        this.provider = useWebSocket
            ? new ethers_1.ethers.providers.WebSocketProvider(rpcUrl)
            : new ethers_1.ethers.providers.JsonRpcProvider(rpcUrl);
        if (signer) {
            this.useSigner(signer.connect(this.provider));
        }
        this.walletNotConnected = !signer;
        await this.initWorld();
    }
    async initWithRpcSync(rpcUrl, useWebSocket) {
        if (!this.world) {
            throw Error('initWorldRpcSync expects the SDK to have been constructed with an abi object');
        }
        this.walletNotConnected = true;
        this.provider = useWebSocket
            ? new ethers_1.ethers.providers.WebSocketProvider(rpcUrl)
            : new ethers_1.ethers.providers.JsonRpcProvider(rpcUrl);
        this.initCustomizedGasContracts();
    }
    async initWorld() {
        if (this.abiUrl) {
            // if abiUrl is not set, than world was already set in the constructor
            const resp = await axios_1.default.get(this.abiUrl, { responseType: 'json' });
            this.world = resp.data.contracts;
        }
        this.initCustomizedGasContracts();
    }
    initCustomizedGasContracts() {
        if (this.provider instanceof customized_gas_web3_provider_1.CustomizedGasWeb3Provider) {
            // Load Tectonic Contracts to enable customized gas fee estimation
            const eligibleContracts = this.world
                .filter((contractState) => contractState.contractType.includes('Tectonic') ||
                contractState.contractType.includes('TErc20') ||
                contractState.contractType.includes('TEther'))
                .map((contractState) => contractState.address);
            this.provider.addCustomizedGasFeeContract(...eligibleContracts);
        }
    }
    useSigner(signer) {
        this.externalSigner = signer;
    }
    clearSigner() {
        this.externalSigner = undefined;
    }
}
exports.TectonicSDK = TectonicSDK;
//# sourceMappingURL=index.js.map